import { useEffect } from 'react'

/**
 * เปิด animation สำหรับ element ที่มี class "animateMe" เมื่อ scroll เข้า viewport
 * ใช้ร่วมกับ data-animation="fadeInUp" และ optional data-animation-delay
 * (ทำงานแบบเดียวกับ theme HTML ที่ใช้ scrollWaypointInit + animate.css)
 */
export function useAnimateOnScroll() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          const el = entry.target as HTMLElement
          const animation = el.getAttribute('data-animation') || 'fadeInUp'
          const delay = el.getAttribute('data-animation-delay')
          el.classList.add('animated', animation)
          if (delay) {
            el.style.animationDelay = delay
          }
          observer.unobserve(el)
        })
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0 }
    )

    const observeAll = () => {
      document.querySelectorAll<HTMLElement>('.animateMe:not(.animated)').forEach((el) => {
        observer.observe(el)
      })
    }

    observeAll()
    const mo = new MutationObserver(observeAll)
    mo.observe(document.body, { childList: true, subtree: true })

    return () => {
      mo.disconnect()
      observer.disconnect()
    }
  }, [])
}
